import legacyErasmusCalls from './erasmusKonkursiData.json';

const DEFAULT_LANGUAGE = 'me';

const normalizeLanguage = (language = DEFAULT_LANGUAGE) => {
  const normalized = String(language || DEFAULT_LANGUAGE).toLowerCase();
  if (normalized.startsWith('en')) return 'en';
  if (normalized.startsWith('me') || normalized.startsWith('sr') || normalized.startsWith('cnr')) return 'me';
  return DEFAULT_LANGUAGE;
};

const getLocalizedValue = (value, language = DEFAULT_LANGUAGE) => {
  if (value === null || value === undefined) return '';
  if (typeof value === 'string') return value;

  const locale = normalizeLanguage(language);
  return value[locale] || value[DEFAULT_LANGUAGE] || value.en || '';
};

const formatDateLabel = (dateValue, fallback = '') => {
  if (fallback) return fallback;
  if (!dateValue) return '';

  const date = new Date(dateValue);
  if (Number.isNaN(date.getTime())) return String(dateValue);

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();

  return `${day}.${month}.${year}.`;
};

const normalizeDocuments = (documents = [], language = DEFAULT_LANGUAGE) => {
  if (!Array.isArray(documents)) return [];

  return documents
    .map((document) => ({
      naziv: getLocalizedValue(document.title, language),
      url: document.url || '',
      type: document.type || document.documentType || '',
    }))
    .filter((document) => document.naziv && document.url);
};

export const buildLegacyErasmusKonkursi = (language = DEFAULT_LANGUAGE) => {
  return legacyErasmusCalls.map((item, index) => {
    const tekst = getLocalizedValue(item.content, language);
    const dokumenti = normalizeDocuments(item.documents, language);
    const rok = getLocalizedValue(item.deadlineLabel, language);
    const destinacija = getLocalizedValue(item.destination, language);

    return {
      id: item.id || `legacy-erasmus-${index + 1}`,
      legacyIndex: item.legacyIndex || index + 1,
      source: 'local',
      slug: item.id || '',
      datum: formatDateLabel(item.publishedDate, item.dateLabel),
      type: item.type || 'javniPoziv',
      logo: item.logoPath || '/assets/img/erasmuskonkursi/adriatiklogo.png',
      ustanova: getLocalizedValue(item.institution, language),
      naslov: getLocalizedValue(item.title, language),
      opis: getLocalizedValue(item.summary, language),
      tekst,
      dokumenti,
      destinacija,
      rok,
      hasMoreInfo: Boolean(tekst || dokumenti.length || rok || destinacija),
    };
  });
};

export default legacyErasmusCalls;
